import { createIconFromSvg } from '../icons';
import { ReactComponent as DraftIcon } from './draft.svg';

/*
This is from a different than usual source and isn't made to respect the usual 0 0 24 24 viewBox
*/
export const Draft = createIconFromSvg(DraftIcon, '0 -960 960 960');
